module.exports = __webpack_public_path__ + "static/media/washington-dc-16.3f44f3ee.jpg";